import { FunctionComponent } from 'react';
import PurchaseSizeSelector from 'components/business/search/PurchaseSizeSelector';

interface Props {
  disabled?: boolean;
  handleDecrementGuests(): void;
  handleIncrementGuests(): void;
  maxSize: number;
  minSize: number;
  partySizeUnit?: string;
  selectedSize: number;
  sizeClassName: string;
  hasInitialFocus?: boolean;
}

const SearchBarGuestSection: FunctionComponent<Props> = ({
  disabled,
  handleDecrementGuests,
  handleIncrementGuests,
  maxSize,
  minSize = 1,
  partySizeUnit,
  selectedSize,
  sizeClassName,
  hasInitialFocus,
}) => {
  return (
    <div className={sizeClassName}>
      <div className="SearchBarSectionSelection">
        <div className="SearchBarSectionSelectionContainer">
          <div className="SearchBarSectionSelectionText">
            <PurchaseSizeSelector
              disabled={disabled}
              maxSize={Math.max(maxSize, 1)}
              minSize={Math.max(minSize, 1)}
              onDecrement={handleDecrementGuests}
              onIncrement={handleIncrementGuests}
              selectedSize={selectedSize}
              partySizeUnit={partySizeUnit}
              hasInitialFocus={hasInitialFocus}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchBarGuestSection;
